// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/system-user-childs/systemUserChildsActions";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../_metronic/_helpers";
import * as uiHelpers from "./UserChildsUIHelpers";

import { Pagination } from "../../../../_metronic/_partials/controls";

import { useUserChildsUIContext } from "./UserChildsUIContext";
import { UserChildsTableActionsColumnFormatter } from "./UserChildsTableActionsColumnFormatter";
import { SystemUserUiSettings } from "../pages/_redux/system-user-childs/SystemUserUiSettings";
import CsvDownload from "react-json-to-csv";

export function UserChildsTable() {
  const user = useSelector((state) => state.auth.user, shallowEqual);

  var systemUserUiSettings = new SystemUserUiSettings();
  systemUserUiSettings.Set(user);

  const userChildsUIContext = useUserChildsUIContext();

  const userChildsUIProps = useMemo(() => {
    return {
      ids: userChildsUIContext.ids,
      setIds: userChildsUIContext.setIds,
      queryParams: userChildsUIContext.queryParams,
      setQueryParams: userChildsUIContext.setQueryParams,
    };
  }, [userChildsUIContext]);

  // Getting curret state of customers list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userChilds }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;

  // Customers Redux state
  const dispatch = useDispatch();
  useEffect(() => {
    // clear selections list
    userChildsUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetch(userChildsUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userChildsUIProps.queryParams, dispatch]);
  // Table columns
  const adminColumns = [
    {
      dataField: "userName",
      text: "USER NAME",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "firstName",
      text: "first Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "lastName",
      text: "last Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    // {
    //   dataField: "systemUserType",
    //   text: "systemUserType",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
  ];

  const columns = [
    {
      dataField: "name",
      text: "ACCOUNT",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "taxId",
      text: "TAX ID",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  var tableColms = columns;

  if (
    systemUserUiSettings.userType.systemUserType < systemUserUiSettings.MANAGER
  ) {
    tableColms = adminColumns;

    if (
      systemUserUiSettings.userType.systemUserType == systemUserUiSettings.ADMIN
    ) {
      adminColumns.push({
        dataField: "childsCount",
        text: "customers",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      });
    }

    tableColms.push({
      dataField: "action",
      text: "Actions",
      formatter: UserChildsTableActionsColumnFormatter,

      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    });
  }
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: userChildsUIProps.queryParams.pageSize,
    page: userChildsUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="_id"
                data={entities === null ? [] : entities}
                columns={tableColms}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  userChildsUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: userChildsUIProps.ids,
                //   setIds: userChildsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
